import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { REJECT_HINT_TYPES } from 'components/hint/hint.constants';
import { TypeConfig } from 'components/hint/hint.interface';

@Component({
  selector: 'cm-rejected-hint-modal',
  templateUrl: './rejected-hint-modal.component.html',
  styleUrls: ['./rejected-hint-modal.component.scss'],
})
export class RejectedHintModalComponent {
  @Input() type: REJECT_HINT_TYPES;
  @Input() notes: string[];
  @Input() config: TypeConfig;
  readonly REJECT_HINT_TYPES = REJECT_HINT_TYPES;

  constructor(private ngbActiveModal: NgbActiveModal) {}

  onModalClose() {
    this.ngbActiveModal.dismiss();
  }

  onModalConfirm() {
    this.ngbActiveModal.close();
  }
}
